import { jsxs as e, jsx as c } from "react/jsx-runtime";
import { SvgIcon as i } from "./SvgIcon.js";
const y = (r) => /* @__PURE__ */ e(i, { ...r, children: [
  /* @__PURE__ */ c("circle", { cx: "8", cy: "4", r: "1.25" }),
  /* @__PURE__ */ c("circle", { cx: "12", cy: "4", r: "1.25" }),
  /* @__PURE__ */ c("circle", { cx: "12", cy: "8", r: "1.25" }),
  /* @__PURE__ */ c("circle", { cx: "12", cy: "12", r: "1.25" }),
  /* @__PURE__ */ c("circle", { cx: "12", cy: "16", r: "1.25" }),
  /* @__PURE__ */ c("circle", { cx: "8", cy: "8", r: "1.25" }),
  /* @__PURE__ */ c("circle", { cx: "8", cy: "12", r: "1.25" }),
  /* @__PURE__ */ c("circle", { cx: "8", cy: "16", r: "1.25" })
] });
export {
  y as Draggable
};
//# sourceMappingURL=Draggable.js.map
